import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import { formatTableDate, paymentApiUrl, readJsonResponse } from '../../utils/payment';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';

export default function AdminPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    pageTitle('Admin Payments');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(paymentApiUrl('/api/admin/payments'))
      .then(readJsonResponse)
      .then((data) => setPayments(data.payments || []))
      .catch((fetchError) => setError(fetchError.message));
  }, []);

  return (
    <>
      <PageHeading title="Admin Payment Logs" bgSrc="/images/service_hero_bg.jpeg" pageLinkText="Admin Payments" />
      <Spacing lg="120" md="70" />
      <Div className="container">
        {error ? <p className="cs-m0" style={{ color: '#ff6b6b' }}>{error}</p> : null}
        <Div style={{ overflowX: 'auto' }}>
          <table className="table" style={{ width: '100%', minWidth: 860 }}>
            <thead>
              <tr>
                <th>Ref No</th>
                <th>Customer</th>
                <th>Amount</th>
                <th>Currency</th>
                <th>Status</th>
                <th>Gateway ID</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.referenceNumber}>
                  <td>{payment.referenceNumber}</td>
                  <td>{payment.customerFullName}</td>
                  <td>{Number(payment.amount).toFixed(2)}</td>
                  <td>{payment.currency}</td>
                  <td>{payment.status}</td>
                  <td>{payment.gatewayId || '-'}</td>
                  <td>{formatTableDate(payment.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Div>
      </Div>
      <Spacing lg="120" md="70" />
    </>
  );
}
